import { stringifyAndParseObj } from 'utils';
import { cloudFunction } from '../parse';

export const fetchAllStripeProductsForAdmin = async () => {
  return cloudFunction('fetchAllStripeProductsForAdmin', {});
};

export const createStripeProduct = async (params: any) => {
  return cloudFunction('createStripeProduct', params);
};

export const fetchStripeProductBySlug = async (slug: string) => {
  const res = await cloudFunction('fetchStripeProductBySlug', { slug });
  return stringifyAndParseObj(res);
};

export const createStripeProductCopy = async (id: string, name: string) => {
  const res = await cloudFunction('createStripeProductCopy', { id, name });
  return stringifyAndParseObj(res);
};


export const updateStripeProduct = async (params: {name?: string; enName?: string; description?: string; 
  enDescription?: string; id: string;productType?: string; heroText: string; howItWorksSteps: Record<string, any>; faqs: Record<string, any>;}) => {
  return cloudFunction('updateStripeProduct', params);
};

export const markStripeProductAsInactive = async (id: string) => {
  return cloudFunction('markStripeProductAsInactive', { id });
};

export const markStripeProductAsActive = async (id: string) => {
  return cloudFunction('markStripeProductAsActive', { id });
};